<template>
  <div class="container container-table">
    <div class="row vertical-10p">
      <template v-for="alert in alerts">
        <b-alert :show="alert.dismiss" dismissible :variant="alert.type" @dismissed="alert.action">
          <h4>
            <i v-if="alert.type == 'success' || alert.type == 'warning'" class="icon fa fa-check"></i>
            <i class="icon fa fa-ban" v-else></i>
            {{'alert_'+alert.type | translate}}!</h4>
          <p v-if="alert.type !== 'danger'">
            {{alert.message}}
          </p>
          <ul v-else>
            <li v-for="e in alert.message">
              {{e}}
            </li>
          </ul>
        </b-alert>
      </template>
        <div class="container">
          <div class="login-box box">
            <div class="login-logo">
              <router-link to="/">
                <img class="img-responsive center-block" src="/static/img/logo-lg.svg">
              </router-link>
            </div>
            <div class="login-box-body">
              <p class="login-box-msg">
                Confirm account
              </p>
              <form @submit.prevent="pepe">
                <div class="form-group has-feedback">
                  <input disabled type="text" class="form-control" placeholder="Username" v-model="username">
                  <span class="fa fa-at form-control-feedback"></span>
                </div>
                <div class="form-group has-feedback">
                  <input v-validate="'required'" :disabled="disabled" class="form-control" name="password" :placeholder="'password' | translate" :type="showPassword ? 'text' : 'password'" v-model="password">
                  <input type="checkbox" v-model="showPassword"><span class="text-muted"> Show password?</span>
                  <span v-show="errors.has('password')" class="small text-danger">{{ errors.first('password') }}</span>
                </div>
                <div class="row">
                  <div class="col-sm-4 col-xs-12 pull-right">
                    <button :disabled="errors.any() || password.length == 0" class="btn btn-success btn-block">
                      <i class="fa fa-check-circle-o mr-5"></i> Confirm
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div class="overlay" v-show="loading">
              <img class="loading-gif" src="/static/img/blabla.svg"/>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'ConfirmAccount',
  data () {
    return {
      loading: false,
      showPassword: false,
      username: window.localStorage.getItem('confirmUser'),
      password: '',
      language: 'de',
      alerts: [],
      disabled: false,
      translate (word) {
        let trans = this.$options.filters.translate(word, this.language)
        if (trans === 'undefined') {
          return false
        } else {
          return trans
        }
      }
    }
  },
  methods: {
    redirect () {
      this.$router.push('/')
    },
    kek () {
      console.log('')
    },
    pepe () {
      this.loading = true
      let body = {
        username: this.username,
        password: this.password,
        activation_token: window.localStorage.getItem('confirmToken')
      }
      API.put('/accounting/user/password-reset', body)
        .then(response => {
          this.loading = false
          let alert = {type: 'success', dismiss: 4, message: 'Ihr Passwort wurde erfolgreich vergeben.', action: this.redirect}
          this.alerts.push(alert)
        })
        .catch(error => {
          this.loading = false
          let alert = {type: 'danger', dismiss: 4, message: [error.response.data.message], action: this.kek}
          this.alerts.push(alert)
        })
    }
  },
  mounted () {
    if (window.localStorage.getItem('IE')) {
      this.disabled = true
      this.$store.commit('pushAlert', {type: 'danger', dismiss: 99, message: 'Bitte beachten Sie, dass die Anmeldung im neuen MyPlace Qualibet über den Internet Explorer nicht möglich ist. Bitte melden Sie sich hierzu über Google Chrome oder Mozilla Firefox an. Vielen Dank.'})
    }
  }
}
</script>

<style>
  .companie-select
  {
    width:80%;
    float: right;
  }
</style>
<style scoped>
  .loading-gif {
    top: 43%;
    left: 39%;
    width: 23%;
    position: absolute;
  }
</style>



// WEBPACK FOOTER //
// src/components/views/ConfirmAccount.vue